// Auto generated file, do not manually modify!
// com.hotpads.renterinfo.web.api.web.v1.renterprofile.RenterInfoRenterProfileWebApiHandler

import type { QueryOptions, UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RenterInfoRenterProfileWebApiHandler_getForPostLeadForm,
  RenterInfoRenterProfileWebApiHandler_getForPostLeadForm_Path,
  RenterInfoRenterProfileWebApiHandler_getForStandalonePage,
  RenterInfoRenterProfileWebApiHandler_getForStandalonePage_Path,
  RenterInfoRenterProfileWebApiHandler_insertOrUpdateForPostLeadForm,
  RenterInfoRenterProfileWebApiHandler_insertOrUpdateForStandalonePage,
} from '@zg-rentals/ts-renter-info-client';

import type {
  RenterInfoRenterProfileGetForPostLeadFormWebApiResponseDto,
  RenterInfoRenterProfileInsertOrUpdateForPostLeadFormWebApiRequestDto,
  RenterInfoRenterProfileInsertOrUpdateForPostLeadFormWebApiResponseDto,
  RenterInfoRenterProfileInsertOrUpdateForStandaloneRequestDto,
  RenterInfoRenterProfileStandalonePageWebApiResponse,
} from '@zg-rentals/ts-renter-info-client';

export type RenterInfoRenterProfileWebApiHandler_getForPostLeadForm_Options = UseQueryOptions<
  RenterInfoRenterProfileGetForPostLeadFormWebApiResponseDto,
  unknown,
  RenterInfoRenterProfileGetForPostLeadFormWebApiResponseDto,
  readonly [string]
>;

const RenterInfoRenterProfileWebApiHandler_getForPostLeadForm_GetKey = () =>
  [RenterInfoRenterProfileWebApiHandler_getForPostLeadForm_Path] as const;

export const RenterInfoRenterProfileWebApiHandler_getForPostLeadForm_queryOptions = ({
  httpClient,
}: { httpClient?: Client } = {}) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RenterInfoRenterProfileWebApiHandler_getForPostLeadForm_GetKey(),
    queryFn: () => RenterInfoRenterProfileWebApiHandler_getForPostLeadForm(httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get renter profile for post lead form
 */
export const useRenterInfoRenterProfileWebApiHandler_getForPostLeadForm = ({
  httpClient,
  ...options
}: Omit<RenterInfoRenterProfileWebApiHandler_getForPostLeadForm_Options, 'queryFn' | 'queryKey'> & {
  httpClient?: Client;
} = {}) => {
  return useQuery({
    ...RenterInfoRenterProfileWebApiHandler_getForPostLeadForm_queryOptions({ httpClient }),
    ...options,
  });
};
useRenterInfoRenterProfileWebApiHandler_getForPostLeadForm.getKey =
  RenterInfoRenterProfileWebApiHandler_getForPostLeadForm_GetKey;

export type RenterInfoRenterProfileWebApiHandler_getForStandalonePage_Options = UseQueryOptions<
  RenterInfoRenterProfileStandalonePageWebApiResponse,
  unknown,
  RenterInfoRenterProfileStandalonePageWebApiResponse,
  readonly [string]
>;

const RenterInfoRenterProfileWebApiHandler_getForStandalonePage_GetKey = () =>
  [RenterInfoRenterProfileWebApiHandler_getForStandalonePage_Path] as const;

export const RenterInfoRenterProfileWebApiHandler_getForStandalonePage_queryOptions = ({
  httpClient,
}: { httpClient?: Client } = {}) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RenterInfoRenterProfileWebApiHandler_getForStandalonePage_GetKey(),
    queryFn: () => RenterInfoRenterProfileWebApiHandler_getForStandalonePage(httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get renter profile for standalone page
 */
export const useRenterInfoRenterProfileWebApiHandler_getForStandalonePage = ({
  httpClient,
  ...options
}: Omit<RenterInfoRenterProfileWebApiHandler_getForStandalonePage_Options, 'queryFn' | 'queryKey'> & {
  httpClient?: Client;
} = {}) => {
  return useQuery({
    ...RenterInfoRenterProfileWebApiHandler_getForStandalonePage_queryOptions({ httpClient }),
    ...options,
  });
};
useRenterInfoRenterProfileWebApiHandler_getForStandalonePage.getKey =
  RenterInfoRenterProfileWebApiHandler_getForStandalonePage_GetKey;

export interface RenterInfoRenterProfileWebApiHandler_insertOrUpdateForPostLeadForm_Args {
  postData: RenterInfoRenterProfileInsertOrUpdateForPostLeadFormWebApiRequestDto;
}

export type RenterInfoRenterProfileWebApiHandler_insertOrUpdateForPostLeadForm_Options = UseMutationOptions<
  RenterInfoRenterProfileInsertOrUpdateForPostLeadFormWebApiResponseDto,
  unknown,
  RenterInfoRenterProfileWebApiHandler_insertOrUpdateForPostLeadForm_Args
>;

/**
 * Insert or update renter profile for post lead form
 */
export const useRenterInfoRenterProfileWebApiHandler_insertOrUpdateForPostLeadForm = ({
  httpClient,
  ...options
}: Omit<RenterInfoRenterProfileWebApiHandler_insertOrUpdateForPostLeadForm_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RenterInfoRenterProfileWebApiHandler_insertOrUpdateForPostLeadForm_Args) =>
      RenterInfoRenterProfileWebApiHandler_insertOrUpdateForPostLeadForm(args.postData, httpClient),
  });
};

export interface RenterInfoRenterProfileWebApiHandler_insertOrUpdateForStandalonePage_Args {
  postData: RenterInfoRenterProfileInsertOrUpdateForStandaloneRequestDto;
}

export type RenterInfoRenterProfileWebApiHandler_insertOrUpdateForStandalonePage_Options = UseMutationOptions<
  RenterInfoRenterProfileStandalonePageWebApiResponse,
  unknown,
  RenterInfoRenterProfileWebApiHandler_insertOrUpdateForStandalonePage_Args
>;

/**
 * Insert or update renter profile for standalone page
 */
export const useRenterInfoRenterProfileWebApiHandler_insertOrUpdateForStandalonePage = ({
  httpClient,
  ...options
}: Omit<RenterInfoRenterProfileWebApiHandler_insertOrUpdateForStandalonePage_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RenterInfoRenterProfileWebApiHandler_insertOrUpdateForStandalonePage_Args) =>
      RenterInfoRenterProfileWebApiHandler_insertOrUpdateForStandalonePage(args.postData, httpClient),
  });
};
